// 当前应用共配请求相关Api

import { uuid, defineAppApi, App } from '@zto/zpage'
import { REQUEST_CODES } from '../consts'
import { reportTraceData } from '../utils/trace'

export default defineAppApi((app: App) => {
  return {
    baseUrl: app.env.apiUrl,

    methods: api => {
      return {
        // 没有权限区分  全部省市区
        async getAreaListAll() {
          // return api.request({
          //   url: 'tuxi.web.WebCommonService.getAreaList'
          // })
          return []
        },
        async getAreaList() {
          return api.fetch({
            url: 'base.getPCUserManagePCD'
          })
        },

        // 获取用户所有组织服务范围并集,格式化街道
        async getAreaListByAccount(accountCode: string) {
          return api.fetch({
            url: 'base.getAccountMergedDeptScopesWithoutStreets',
            data: { accountCode }
          })
        },

        // 获取用户-量本利-省市区
        async getAreaListByQcp() {
          return api.fetch({
            url: 'kdcs.listAllPDC'
          })
        },

        /** 获取图形验证码 */
        async getVerifyCode() {
          const uuidStr = uuid()
          const res = await api.fetch({
            url: 'base.getVerifyCode',
            data: { uuid: uuidStr }
          })

          return { ...res, uuid: uuidStr }
        },

        // 获取组织数据
        async getDeptTrees() {
          return api.fetch({
            url: 'base.getDeptTrees'
          })
        },

        // 获取组织数据（根据当前账号组织岗位过滤）
        async getCityDeptTree() {
          return api.fetch({
            url: 'base.getCityDeptTree'
          })
        },

        // 埋点上报
        async addEventTracking(data: any) {
          return api.fetch({
            reqCode: REQUEST_CODES.TRACE,
            url: 'workbench.pc.CommonService.buriedPoint',
            data
          })
        },

        // 自定义埋点上报方法
        reportTraceData(app: any, event: any) {
          return reportTraceData(app, event)
        }
      }
    }
  }
})
